import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidateCountry, ValidateState } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import {
    AddressFieldDisplayModel,
} from "@insite/client-framework/Types/ApiModels";

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

replaceInChain(chain, ValidateCountry, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter; // Poolcorp Custom Code
    const countries = getCurrentCountries(props.getState());
    if (!countries) {
        throw new Error("Cannot validate country. The website countries have not been loaded yet.");
    }

    const { country } = props.parameter.address; // Poolcorp Custom Code

    if (
        addressFieldDisplayCollection.country?.isVisible && // Poolcorp Custom Code
        validationRules.country?.isRequired && // Poolcorp Custom Code
        countries.length > 1 &&
        !country &&
        addressFieldDisplayCollection.country
    ) {
        props.addressErrors.country = getRequiredErrorMessage(addressFieldDisplayCollection.country);
    }
});

replaceInChain(chain, ValidateState, props => {
    const { country, state } = props.parameter.address;
    const { addressFieldDisplayCollection } = props.parameter;
    const reduxState = props.getState(); // Poolcorp Custom Code
    const countries = getCurrentCountries(reduxState);
    const useOneTimeAddress = reduxState.pages.checkoutShipping.useOneTimeAddress; // Poolcorp Custom Code
    const currentUserIsGuest = getCurrentUserIsGuest(reduxState); // Poolcorp Custom Code

    if (!countries) {
        throw new Error("Cannot validate country. The website countries have not been loaded yet.");
    }

    if (!country) {
        // This is fine to simply return because the address country
        // is validated in the previous handler. If the country has not
        // been selected yet, it doesn"t make sense to show an error for the state.
        return;
    }

    const countryLookup = countries.find(c => c.id === country.id);
    if (
        countries.length > 0 &&
        countryLookup?.states &&
        countryLookup.states.length > 0 &&
        (useOneTimeAddress || currentUserIsGuest) && // Poolcorp Custom Code
        !state &&
        addressFieldDisplayCollection.state
    ) {
        props.addressErrors.state = getRequiredErrorMessage(addressFieldDisplayCollection.state);
    }
});
